//
// DefinitionMenu for RecordInspector
//

import { observer } from 'mobx-react-lite'
import { useStore } from '../../../stores'

import { Menu, MenuDivider, MenuItem } from '../../../components'
import { RecordDefinitionChangePanel } from '../../../panels'

export const DefinitionMenu = observer(function DefinitionMenu({
    worksheet,
    onAction,
}) {
    const { app, data } = useStore()
    const definition = data.definitions.get(worksheet.record.definition)
    const isExtended = definition && definition.is_extended

    const _onAction = (action, parameter) => {
        onAction && onAction(action, parameter)
    }

    return (
        <Menu>
            <MenuItem
                onClick={() => {
                    _onAction(isExtended ? 'reveal_original' : 'reveal_definition')
                }}
            >
                {app.text('Reveal in Schema workspace')}
            </MenuItem>
            <MenuDivider />
            <MenuItem
                disabled={worksheet.record.is_link}
                className="cc-notice"
                submenu={
                    <RecordDefinitionChangePanel
                        worksheet={worksheet}
                        title={app.text("Change record's definition")}
                        perRecordOnlyWarning={isExtended}
                        onChangeDefinition={new_definition_gid => {
                            _onAction('change_definition', new_definition_gid)
                        }}
                        onCancel={() => _onAction('cancel')}
                    />
                }
            >
                {app.text('Change')}
            </MenuItem>
        </Menu>
    )
})
